import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface AddICSPrintDetailsInterface {
  printUsers: {
    splitReferance?: string
    user?: string
    printedDate?: any
  }
}

export const useAddICSPrintDetails = () => {
  const mutate = useMutation(({ printUsers }: AddICSPrintDetailsInterface) => {
    return postAPI(`ICSBulkConsignment/AddICSPrintDetails`, {
      printICSUsers: {
        splitReferance: printUsers?.splitReferance,
        user: printUsers?.user,
        printedDate: printUsers?.printedDate,
      },
    })
  })

  return mutate
}
